export default {
  methods: {
    mixinsDateFormatDate(timestamp, reversed = false) {
      const date = new Date(timestamp);
      const month = `0${date.getMonth() + 1}`.slice(-2);
      const day = `0${date.getDate()}`.slice(-2);
      if (reversed === true) {
        return `${date.getFullYear()}-${month}-${day}`;
      }
      return `${day} - ${month} - ${date.getFullYear()}`;
    },
    mixinsDateLocaleToDisplay(timestamp) {
      const d = new Date(timestamp);
      return d.toLocaleString('fr-FR');
    },
  },
};
